export const Config = {
  apiUrl: window.location.origin,
    //reCAPTCHASiteKey: "6Lcjm68qAAAAAJ7-iVzCTuy4o__O0lGjgmIHwTTl",//local
    reCAPTCHASiteKey: "6Lc8m68qAAAAALwRse3hQlIOdMOh-o72WYDiVTbq"//dev
    //reCAPTCHASiteKey: "6LdJm68qAAAAALygLiUg_wwaH7xKZrHo2ncrzlYt"//prod

};
